<template>
	<div>
		<v-data-table v-if="data.items" :headers="headers" :items="data.items" :hide-actions="true" :loading="loading">
			<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
			<template slot="items" slot-scope="props">
				<td>
					<template v-if="props.item.published">
						<v-btn fab icon small @click="handleUnpublish(props.item)"><v-icon large color="green">toggle_on</v-icon></v-btn>
					</template>
					<template v-else>
						<v-btn fab icon small @click="handlePublish(props.item)"><v-icon large color="grey lighten-2">toggle_off</v-icon></v-btn>
					</template>
				</td>
				<td :class="{'-unpublished': !props.item.published}">
					<v-img width="50" v-if="props.item.imageUrl" :src="props.item.imageUrl" class="white elevation-0"></v-img>
				</td>
				<td :class="{'-unpublished': !props.item.published}">
					<template v-if="props.item.brand">
						{{ props.item.brand.title }}
					</template>
					<template v-else>
						{{ props.item.title }}
					</template>
				</td>
				<td :class="{'-unpublished': !props.item.published}">
					{{ props.item.message|truncate(200) }}
				</td>
				<td class="justify-center text-xs-center pa-0">
					<v-btn fab icon small @click="handleEdit(props.item)"><v-icon>edit</v-icon></v-btn>
					<v-btn fab icon small @click="handleDelete(props.item)"><v-icon>delete</v-icon></v-btn>
				</td>
			</template>
			<template slot="no-data">
 				<v-btn color="primary" @click="handlePageChange(1)">Reset</v-btn>
			</template>
		</v-data-table>

	    <div class="pt-2 pb-5">
			<v-pagination v-model="data.page" :length="pages" :total-visible="6"></v-pagination>
	    </div>

		<v-btn fixed dark fab bottom right color="primary" @click="handleAdd">
			<v-icon>add</v-icon>
        </v-btn>

		<v-dialog v-model="dialog" scrollable max-width="690px">
<!-- 
			<v-btn slot="activator" fixed dark fab bottom right color="primary">
				<v-icon>add</v-icon>
	        </v-btn>
 -->
		    <v-card>
		        <v-card-title class="headline grey lighten-2" primary-title>
		            {{ formTitle }}
		        </v-card-title>
		        <v-card-text>
		            <v-container grid-list-md>
		            	<v-form ref="form" v-model="valid" class="pb-5" lazy-validation>
			                <v-layout wrap>
			                	<v-flex xs12>
			                		<brand-autocomplete v-model="tip.brand"></brand-autocomplete>
			                	</v-flex>
			                	<!--
			                    <v-flex xs12>
			                        <v-text-field v-model="tip.title" label="Title"></v-text-field>
			                    </v-flex>
			                	-->
			                    <v-flex xs12>
			                        <v-textarea v-model="tip.message" label="Message"></v-textarea>
			                    </v-flex>
			                    <v-flex xs12>
			                    	<image-upload class="pa-0" label="Image" :resize-to="{width: 600, height: 315}" v-model="tip.imageUrl"></image-upload>
									<v-flex v-if="tip.imageUrl">
										<img class="img-preview elevation-1 mt-2" :src="tip.imageUrl" height="210">
									</v-flex>
			                    </v-flex>
			                </v-layout>
			            </v-form>
		            </v-container>
		        </v-card-text>
				<v-divider></v-divider>
		        <v-card-actions>
		            <v-spacer></v-spacer>
		            <v-btn color="blue darken-1" flat @click="dialog = false">Cancel</v-btn>
		            <v-btn color="blue darken-1" flat :loading="saving" @click="handleSave">Save</v-btn>
		        </v-card-actions>
		    </v-card>
		</v-dialog>

	</div>
</template>

<script>
	import * as config from '@/config'
    import * as types from '@/stores/mutation-types'

    import BrandAutocomplete from '@/components/AutocompleteBrand.vue'
	import ImageUpload from '@/components/ImageUpload.vue'

	export default {
		components: {
			'brand-autocomplete': BrandAutocomplete,
			'image-upload': ImageUpload
		},
		props: {
			communityId: {
				type: Number,
				default: 0
			}
		},
		data () {
			return {
				headers: [
					{
						sortable: false,
						width: 75
					},
					{
						text: 'Image',
						align: 'center',
						sortable: false,
						width: '100'
					},
					{
						text: 'Title',
						align: 'left',
						sortable: false,
						width: '250'
					},
					{
						text: 'Message',
						align: 'left',
						sortable: false,
					},
					{ 
						align: 'center', 
						sortable: false,
						width: '150'
					}
				],
				currentYmd: (new Date().toISOString().substring(0, 19).replace('T', ' ')),
	            data: {
	                page: 1,
	                totalRecords: 0,
	                items: []
	            },
				pageSize: 10,
				loading: true,
				saving: false,
				valid: true,
				dialog: false,
				formTitle: 'New Tip',
				tip: {
					id: null,
					communityId: null,
					brand: null,
					brandId: null,
					productId: null,
					imageUrl: '',
					title: '',
					message: '',
					published: 0,
					publishedOn: null
				},
				rules: {
					text: [
						v => !!v || 'Field is required'
					],					
					number: [
						v => !!v || 'Field is required',
						v => (parseInt(v) > 0) || 'Value must be greater than 0'
					],					
				},
			}
		},
		computed: {
        	apiUrl () {
        		return `${config.BASE_URL}/community/${this.communityId}/tip`
        	}, 
			pages () {
				if (this.pageSize == null || this.data.totalRecords == null) {
					return 0
				}
				return Math.ceil(this.data.totalRecords / this.pageSize)
			}
		},
		created () {
			this.handlePageChange(1)
		},
		methods: {
			resetItemOnDialog () 
			{
				return new 
					Promise((resolve) => {
						this.tip = {
							id: null,
							communityId: this.communityId,
							brand: null,
							brandId: null,
							productId: null,
							imageUrl: '',
							title: '',
							message: '',
							published: 0,
							publishedOn: null
						}

						resolve(true)
					})
			},
	    	handleAdd ()
	    	{
	    		this.resetItemOnDialog()
	    			.then(() => {
	    				this.formTitle = 'New Tip'
	    				this.dialog = true
	    			})
	    	},
	    	handleEdit (itemRow)
	    	{
				axios.get(`${this.apiUrl}/${itemRow.id}`)
					.then((response) => {
						this.tip = response.data.data
						this.formTitle = 'Edit Tip'
						this.dialog = true
					})
	    	},
	        handleDelete (itemRow)
	        {
	        	var id = itemRow.id;

	        	this.$swal({
	        		icon: 'warning',
	        		text: `Remove "${itemRow.title}" ?`,
	        		showCancelButton: true
	        	}).then(response => {
	        		if (response.value) {
			    		axios.delete(`${this.apiUrl}/${itemRow.id}`)
				    		.then((response) => {
				    			this.handlePageChange(this.data.page)
				    		}).catch((error) => {
				    			this.$store.commit(types.SET_ERROR_MSG, 'Could not remove item.')
							})
	        		}
	        	})
	        },
	        handlePublish (itemRow) 
	        {
	        	var id = itemRow.id;

	    		axios.post(`${this.apiUrl}/${itemRow.id}/publish`)
		    		.then((response) => {
		    			this.handlePageChange(this.data.page)
		    		}).catch((error) => {
		    			this.$store.commit(types.SET_ERROR_MSG, 'Could not publish item.')
					})
	        },
	        handleUnpublish (itemRow)
	        {
	        	var id = itemRow.id;

	    		axios.delete(`${this.apiUrl}/${itemRow.id}/publish`)
		    		.then((response) => {
		    			this.handlePageChange(this.data.page)
		    		}).catch((error) => {
		    			this.$store.commit(types.SET_ERROR_MSG, 'Could not unpublish item.')
					})
	        },
	        handlePageChange (pageNum)
	        {
	            var apiUrl = this.apiUrl;

            	apiUrl += `/paginate?limit=${this.pageSize}`
	            if (parseInt(pageNum, 10) > 1) {
	                apiUrl += `&page=${parseInt(pageNum, 10)}`
	            }

	            this.loading = true

	            axios.get(apiUrl)
	                .then((response) => {
	                    this.data = response.data.data
	                    this.data.items = response.data.data.tipList

	                    this.loading = false
	                });
	        },
	        handleSave ()
	        {
		    	if (this.$refs.form.validate()) {
		    		if (this.tip.brand) {
		    			this.tip.brandId = this.tip.brand.id
		    		}

			    	if (this.tip.id) {
				    	axios.put(`${this.apiUrl}/${this.tip.id}`, this.tip)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				this.handlePageChange(this.data.page)
				    				this.dialog = false
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							});
			    	} else {
				    	axios.post(this.apiUrl, this.tip)
				    		.then((response) => {
				    			if ((response.data.httpStatusCode == 200) || (response.data.httpStatusCode == 201)) {
				    				this.handlePageChange(1)
				    				this.dialog = false
				    			} else {
				    				this.$store.commit(types.SET_ERROR_MSG, response.data.message)
				    			}
				    		}).catch(function (error) {

							});
			    	}
			    }
	        }
		},
		watch: {
			'data.page' (to, from) {
				if (to !== from) {
					this.handlePageChange(to)
				}
			},
			communityId (value) {
				this.handlePageChange(1)
			}
		},
		filters: {
			truncate (text, stop, clamp) {
			    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
			}
		}
	}
</script>

<style lang="scss">
	table {
		tbody {
			tr {
				td {
					a {
						text-decoration: none !important;
						&:hover {
							text-decoration: none !important;
						}
					}
					&.-unpublished {
						opacity: .4;
					}
				}
			}
		}
	}
	.v-icon[class*="fa-"] {
		font-size: 18px;
	}
	.score-input {
		width: 290px;
	}
</style>